export function useAppContext(){
    function mountAppContext(apps:any){
        for (const iterator in apps) {
            window[iterator] = apps[iterator]
        }
    }
    return { mountAppContext }
}